var _defs, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoundationSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "foundation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 288.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#eb9c2c;}.cls-1{fill-rule:evenodd;}.cls-2{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "94.21 129.71 113.69 129.71 113.69 113.09 185.29 113.09 185.29 129.71 205.05 129.71 205.05 248.56 205.05 253.14 205.05 274.62 168.67 274.62 168.67 253.14 130.3 253.14 130.3 274.62 94.21 274.62 94.21 253.14 94.21 248.56 94.21 129.71"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.5,
    y: 134.29,
    width: 15.76,
    height: 16.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.71,
    y: 229.08,
    width: 15.76,
    height: 15.19
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.5,
    y: 229.08,
    width: 15.76,
    height: 15.19
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.71,
    y: 197.29,
    width: 15.76,
    height: 15.76
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.71,
    y: 166.08,
    width: 15.76,
    height: 15.47
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.71,
    y: 134.29,
    width: 15.76,
    height: 16.04
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.5,
    y: 197.29,
    width: 15.76,
    height: 15.76
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 157.5,
    y: 166.08,
    width: 15.76,
    height: 15.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.62,53c-9.71,0-20.15,6-20.94,19.26h41.89C169.77,59,159.34,53,149.62,53Z",
    transform: "translate(0 -6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.84,38.2a9.22,9.22,0,1,0-9.21,9.23A9.23,9.23,0,0,0,158.84,38.2Z",
    transform: "translate(0 -6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.63,6a44.6,44.6,0,1,0,44.59,44.6A44.6,44.6,0,0,0,149.63,6Zm22.64,69.52H127a1.64,1.64,0,0,1-1.64-1.65c0-7.45,2.64-13.72,7.63-18.14A24.28,24.28,0,0,1,145.65,50a12.51,12.51,0,1,1,7.95,0,24.32,24.32,0,0,1,12.68,5.71c4.95,4.38,7.59,10.6,7.63,18a1,1,0,0,1,0,.17A1.65,1.65,0,0,1,172.27,75.52Z",
    transform: "translate(0 -6)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.4,106.18c-9.72,0-20.15,6-21,19.26h41.9C275.55,112.22,265.12,106.18,255.4,106.18Z",
    transform: "translate(0 -6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.62,91.41a9.22,9.22,0,1,0-9.22,9.24A9.23,9.23,0,0,0,264.62,91.41Z",
    transform: "translate(0 -6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255.4,59.22A44.6,44.6,0,1,0,300,103.81,44.59,44.59,0,0,0,255.4,59.22Zm22.65,69.51H232.76a1.64,1.64,0,0,1-1.65-1.64c0-7.45,2.64-13.73,7.63-18.15a24.43,24.43,0,0,1,12.69-5.71,12.51,12.51,0,1,1,7.94,0,24.47,24.47,0,0,1,12.69,5.71c4.95,4.39,7.59,10.6,7.63,18,0,.06,0,.11,0,.17A1.64,1.64,0,0,1,278.05,128.73Z",
    transform: "translate(0 -6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.59,106.18c-9.72,0-20.15,6-20.94,19.26H65.54C64.74,112.22,54.31,106.18,44.59,106.18Z",
    transform: "translate(0 -6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.81,91.41a9.22,9.22,0,1,0-9.21,9.24A9.23,9.23,0,0,0,53.81,91.41Z",
    transform: "translate(0 -6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.6,59.22a44.6,44.6,0,1,0,44.59,44.59A44.59,44.59,0,0,0,44.6,59.22Zm22.64,69.51H22a1.64,1.64,0,0,1-1.65-1.64c0-7.45,2.64-13.73,7.63-18.15a24.43,24.43,0,0,1,12.69-5.71,12.51,12.51,0,1,1,7.94,0,24.47,24.47,0,0,1,12.69,5.71c5,4.39,7.59,10.6,7.63,18,0,.06,0,.11,0,.17A1.64,1.64,0,0,1,67.24,128.73Z",
    transform: "translate(0 -6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.66,267.3c.19-2.65-3.85-21.66-8-25.77a2.35,2.35,0,0,0-1.64-.83c-4.87,0-10,23.07-10,25.95a12.26,12.26,0,0,0,8,10.79c-.08,2-.12,3.31-.12,3.34a.61.61,0,0,0,.16.42.58.58,0,0,0,.41.17h3.16a.57.57,0,0,0,.41-.17.58.58,0,0,0,.17-.41s0-.66-.08-3.23C83.22,275.44,84.55,268.81,84.66,267.3Z",
    transform: "translate(0 -6)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.28,280.64c.19-2.65-3.84-21.66-7.94-25.78A2.41,2.41,0,0,0,48.7,254c-4.88,0-10,23.07-10,26a12.25,12.25,0,0,0,8,10.78c-.07,2-.11,3.32-.12,3.34a.59.59,0,0,0,.17.42.56.56,0,0,0,.41.18h3.16a.55.55,0,0,0,.4-.18.57.57,0,0,0,.17-.41s0-.65-.07-3.22C56.84,288.78,58.17,282.14,58.28,280.64Z",
    transform: "translate(0 -6)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.28,280.64c.19-2.65-3.85-21.66-7.94-25.78a2.41,2.41,0,0,0-1.64-.82c-4.88,0-10,23.07-10,26a12.25,12.25,0,0,0,8,10.78c-.07,2-.11,3.32-.12,3.34a.59.59,0,0,0,.17.42.56.56,0,0,0,.41.18h3.15a.56.56,0,0,0,.41-.18.57.57,0,0,0,.17-.41s0-.65-.07-3.22C256.84,288.78,258.17,282.14,258.28,280.64Z",
    transform: "translate(0 -6)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M233.22,267.3c.19-2.65-3.85-21.66-7.95-25.77a2.35,2.35,0,0,0-1.64-.83c-4.87,0-10,23.07-10,25.95a12.26,12.26,0,0,0,8,10.79c-.08,2-.12,3.31-.12,3.34a.61.61,0,0,0,.16.42.58.58,0,0,0,.41.17h3.16a.58.58,0,0,0,.41-.17.53.53,0,0,0,.16-.41s0-.66-.07-3.23C231.78,275.44,233.11,268.81,233.22,267.3Z",
    transform: "translate(0 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundationSelected);
export default __webpack_public_path__ + "static/media/foundation-selected.a1d2ed0560cf347910c21a3dd06c867f.svg";
export { ForwardRef as ReactComponent };